var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryptocurrencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 12.6972H21.8256C22.6736 12.6972 23.4868 13.0341 24.0864 13.6337C24.686 14.2332 25.0228 15.0465 25.0228 15.8944C25.0228 16.7424 24.686 17.5556 24.0864 18.1552C23.4868 18.7547 22.6736 19.0916 21.8256 19.0916M21.8256 19.0916C22.6736 19.0916 23.4868 19.4284 24.0864 20.028C24.686 20.6276 25.0228 21.4408 25.0228 22.2888C25.0228 23.1367 24.686 23.9499 24.0864 24.5495C23.4868 25.1491 22.6736 25.486 21.8256 25.486H13.2998M21.8256 19.0916H15.4313M15.4313 12.6972V25.486M16.497 9.50005V12.6972M20.7599 9.50005V12.6972M16.497 25.486V28.6831M20.7599 25.486V28.6831M34.1998 19C34.1998 27.3948 27.3945 34.2 18.9998 34.2C10.6051 34.2 3.7998 27.3948 3.7998 19C3.7998 10.6053 10.6051 3.80005 18.9998 3.80005C27.3945 3.80005 34.1998 10.6053 34.1998 19Z",
    stroke: "#C5C5C5",
    strokeWidth: 3.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptocurrencyIcon);
export default __webpack_public_path__ + "static/media/cryptocurrency-icon.410761b053ecad673cd13e61774ac3fe.svg";
export { ForwardRef as ReactComponent };